<template>
  <b-tab title="Consumíveis" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE CONSUMIVEIS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterConsumiveis(filtro)" :fields="fields.consumivel">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="consumivel-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pela descrição do consumível."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <consumivel-modal ref="editor" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useConsumivelStore } from "@/stores/ConsumivelStore";
import Consumivel from "@/models/Consumivel";
import TableFields from "@/tools/TableFields";
import ConsumivelModal from "@/components/modals/inspecao/ConsumivelModal";

export default {
  name: "ConsumivelTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      consumivel: new Consumivel(),
    };
  },

  components: {
    "consumivel-modal": ConsumivelModal,
  },

  methods: {
    adicionar() {
      this.consumivel = new Consumivel();
      this.$refs.editor.call(this.consumivel);
    },

    editar(consumivel) {
      this.$refs.editor.call(consumivel);
    },
  },

  setup() {
    const store = useSgcqStore();
    const consumivelStore = useConsumivelStore();
    const { getFilterConsumiveis } = storeToRefs(consumivelStore);

    return {
      store,
      consumivelStore,
      getFilterConsumiveis,
    };
  },
};
</script>

<style lang="scss" scoped>
#consumivel-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
